/* GA4 event tracking — replicates the live site's src/lib/ga4.ts events with the
   same names and parameters so reporting stays continuous across the migration:
   view_item, add_to_cart, search, appointment_booking,
   view_practitioner, view_brand, blog_read, generate_lead.
   (page_view is automatic via the gtag config in theme.liquid; begin_checkout and the
   rest of checkout/purchase come from the customer-events pixel — see docs/ga4-checkout-pixel.md.) */
(function () {
  function ga() {
    if (typeof window.gtag === 'function') window.gtag.apply(null, arguments);
  }
  var tpl = window.__lumTemplate || '';

  function money(el) {
    var m = (el && el.textContent || '').replace(/[^0-9.]/g, '');
    return m ? parseFloat(m) : undefined;
  }

  /* ---- page-type events ---- */

  // product page: view_item
  var pj = document.querySelector('[data-product-json]');
  if (tpl === 'product' && pj) {
    try {
      var product = JSON.parse(pj.textContent);
      var v = product.variants && product.variants[0];
      ga('event', 'view_item', {
        currency: 'CAD',
        value: v ? v.price / 100 : undefined,
        items: [{
          item_id: String(v ? v.id : product.id),
          item_name: product.title,
          item_brand: product.vendor,
          item_category: product.type || undefined,
          price: v ? v.price / 100 : undefined,
          quantity: 1
        }]
      });
    } catch (e) { /* no-op */ }
  }

  // practitioner profile: view_practitioner
  if (document.querySelector('.pract-bio')) {
    var pname = document.querySelector('h1');
    var prole = document.querySelector('.text-lg.text-primary');
    ga('event', 'view_practitioner', {
      practitioner_name: pname ? pname.textContent.trim() : '',
      service_type: prole ? prole.textContent.trim() : ''
    });
  }

  // brand page: view_brand
  if (document.querySelector('[data-brand-root]')) {
    ga('event', 'view_brand', {
      brand_name: document.querySelector('[data-brand-root]').getAttribute('data-vendor') || ''
    });
  }

  // blog article: blog_read
  if (tpl === 'article') {
    var at = document.querySelector('h1');
    ga('event', 'blog_read', { article_title: at ? at.textContent.trim() : '' });
  }

  /* ---- interaction events (delegated) ---- */

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;

    // add_to_cart
    if (/\/cart\/add/.test(form.getAttribute('action') || '')) {
      var idInput = form.querySelector('input[name="id"]');
      var qtyInput = form.querySelector('input[name="quantity"]');
      var qty = qtyInput ? parseInt(qtyInput.value || '1', 10) : 1;
      var nameEl = document.querySelector('[data-product-json]') ? document.querySelector('h1')
        : (form.closest('.group') || form.parentElement).querySelector('h3');
      var priceEl = (form.closest('.group') || form.parentElement).querySelector('.text-lg.font-bold') ||
        document.getElementById('ProductPrice');
      ga('event', 'add_to_cart', {
        currency: 'CAD',
        value: (money(priceEl) || 0) * qty,
        items: [{
          item_id: idInput ? idInput.value : '',
          item_name: nameEl ? nameEl.textContent.trim() : '',
          price: money(priceEl),
          quantity: qty
        }]
      });
    }

    // search
    if (/\/search/.test(form.getAttribute('action') || '')) {
      var q = form.querySelector('input[name="q"]');
      if (q && q.value.trim()) ga('event', 'search', { search_term: q.value.trim() });
    }

    // generate_lead on contact forms (insurance, careers, contact)
    if (/^\/contact/.test(form.getAttribute('action') || '')) {
      var subj = form.querySelector('input[name="contact[Subject]"], input[name="contact[Position]"]');
      ga('event', 'generate_lead', { form_name: subj ? subj.value : 'contact' });
    }
  }, true);

  document.addEventListener('click', function (e) {
    // appointment_booking on any Jane App link
    var jane = e.target.closest && e.target.closest('a[href*="janeapp"]');
    if (jane) {
      var isPract = !!document.querySelector('.pract-bio');
      var h1 = document.querySelector('h1');
      ga('event', 'appointment_booking', {
        service_type: !isPract && h1 ? h1.textContent.trim() : (document.title.split('—')[0] || '').trim(),
        practitioner_name: isPract && h1 ? h1.textContent.trim() : undefined,
        booking_url: jane.getAttribute('href')
      });
      return;
    }
    // begin_checkout is sent by the GA4 customer-events pixel when checkout really
    // starts (it also sees Buy-it-now and Shop Pay); sending it here too counted it twice.
  }, true);
})();
